var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import OutsideClickHandler from 'react-outside-click-handler';
import Button from '../button';
import DropdownAddition from '../dropdown-addition';
import Icon from '../icon';
var AddItemDrppdown = /** @class */ (function (_super) {
    __extends(AddItemDrppdown, _super);
    function AddItemDrppdown(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClickButton = function () {
            _this.setState({ isDropdownExpand: true });
            _this.props.onClick && _this.props.onClick();
        };
        _this.handleChangeValue = function (event, target) {
            if (target.value) {
                _this.setState({ isDropdownExpand: false });
                _this.props.onChange && _this.props.onChange(event, target);
            }
        };
        _this.state = {
            isDropdownExpand: false,
        };
        return _this;
    }
    AddItemDrppdown.prototype.render = function () {
        var _this = this;
        var isDropdownExpand = this.state.isDropdownExpand;
        var _a = this.props, label = _a.label, icon = _a.icon;
        return (React.createElement(OutsideClickHandler, { onOutsideClick: function () { return _this.setState({ isDropdownExpand: false }); } }, !isDropdownExpand ? (React.createElement(Button, { transparent: true, onClick: this.handleClickButton },
            React.createElement(Icon, { name: icon ? icon : 'plus-fill' }),
            React.createElement(FormattedMessage, { id: label ? "button." + label.replace(' ', '_') : 'button.add', defaultMessage: label ? label : "Add" }))) : (React.createElement(DropdownAddition, { open: isDropdownExpand, options: this.props.options, placeholder: this.props.placeholder, onChange: this.handleChangeValue, value: this.props.value, disableAddition: true }))));
    };
    return AddItemDrppdown;
}(React.Component));
export default AddItemDrppdown;
//# sourceMappingURL=index.js.map